// dnd-kit строит collisionRect как initial rect (экранные px, getBoundingClientRect) +
// transform (внутренние px zoom-контейнера — их и делит createScaleModifier). Из-за этого
// collisionRect уезжает дальше, чем элемент виден на экране: на малых масштабах курсор,
// сдвинутый на N экранных px, даёт transform N/scale, а collisionRect — на N/scale
// внутренних px, что кажется браузеру тем же N/scale «экранных» px. Приводим сдвиг
// collisionRect обратно к экранным px, иначе дроп попадает не туда, куда смотрит автор.
import { closestCenter, type ClientRect, type CollisionDetection } from '@dnd-kit/core'

export const correctRectForScale = (
  initial: ClientRect,
  translated: ClientRect,
  scale: number,
): ClientRect => {
  const left = initial.left + (translated.left - initial.left) * scale
  const top = initial.top + (translated.top - initial.top) * scale
  return {
    ...translated,
    left,
    top,
    right: left + translated.width,
    bottom: top + translated.height,
  }
}

export const createScaleCollision =
  (scale: number): CollisionDetection =>
  (args) => {
    const initial = args.active.rect.current.initial
    if (!scale || scale <= 0 || scale === 1 || !initial) return closestCenter(args)
    return closestCenter({
      ...args,
      collisionRect: correctRectForScale(initial, args.collisionRect, scale),
    })
  }
